module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "logo-container"
    }
  }, [(_vm.auth.user !== null) ? _c('p', [_vm._v("Logged in with " + _vm._s(_vm.auth.user.email))]) : _c('p', [_vm._v("not logged in")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.auth.loaded) ? _c('div', [_c('router-view')], 1) : _c('div', [_c('loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "id": "logo",
      "src": require("./assets/logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-97ec0b7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 130
// module chunks = 1